
  import { Record, Partial, Static, Number, String, Always, Intersect2, Constraint, Literal } from 'runtypes';

  export const ___baseEventTypeDefinition = Record({
  eventId: Literal(97),
  sender_game_id: Number.withConstraint(x => x >= 1 && x <= 100),
  sender_network_id: Number.withConstraint(x => x >= 1 && x <= 1000),
  sender_instance_id: Number.withConstraint(x => x >= 1 && x <= 1000),
  sender_player_id: Number.withConstraint(x => x >= 0),
  action: String.withConstraint(x => x.length <= 20),
}).And(Partial({
  receiver_game_id: Number.withConstraint(x => x >= 0 && x <= 100),
  receiver_network_id: Number.withConstraint(x => x >= 0 && x <= 1000),
  receiver_instance_id: Number.withConstraint(x => x >= 0 && x <= 1000),
  receiver_player_id: Number.withConstraint(x => x >= 0),
  refer_method: String.withConstraint(x => x.length <= 20),
  trigger: String.withConstraint(x => x.length <= 20),
  external_inviter_id: String.withConstraint(x => x.length <= 50),
  external_invited_id: String.withConstraint(x => x.length <= 50),
  sender_level: Number.withConstraint(x => x >= 0),
}));
  export const ___completeEventTypeDefinition = Record({
  eventId: Literal(97),
  sender_game_id: Number.withConstraint(x => x >= 1 && x <= 100),
  sender_network_id: Number.withConstraint(x => x >= 1 && x <= 1000),
  sender_instance_id: Number.withConstraint(x => x >= 1 && x <= 1000),
  sender_player_id: Number.withConstraint(x => x >= 0),
  action: String.withConstraint(x => x.length <= 20),
}).And(Partial({
  receiver_game_id: Number.withConstraint(x => x >= 0 && x <= 100),
  receiver_network_id: Number.withConstraint(x => x >= 0 && x <= 1000),
  receiver_instance_id: Number.withConstraint(x => x >= 0 && x <= 1000),
  receiver_player_id: Number.withConstraint(x => x >= 0),
  refer_method: String.withConstraint(x => x.length <= 20),
  trigger: String.withConstraint(x => x.length <= 20),
  external_inviter_id: String.withConstraint(x => x.length <= 50),
  external_invited_id: String.withConstraint(x => x.length <= 50),
  sender_level: Number.withConstraint(x => x >= 0),
}));

  export type Event = Static<typeof ___baseEventTypeDefinition>;

  /** The event type with the shared values added */
  export type EventWithCommonParameters = Static<typeof ___completeEventTypeDefinition>;

  export const validateEvent = (o: any) => ___completeEventTypeDefinition.validate(o);

  export const ID = 97;
  